<template>
    <div class="mt--10">
        <div class="client__notes">
            <div class="">                        
                <template v-if="pageState.loading">
                    <PageSpinner />
                </template>
                    
                <EmptyPage v-else-if="pageState.err" state="error" @action="handleFetchAllIntegrations" />
                                        
                <template v-else>
                    <div class="integration__active__wrap mt--20">
                        <div
                            v-for="(item, index) in integrations" 
                            :key="index" class="settings__integrations__card__item cursor-pointer h--100"
                            :class="{ 'disabled': selectedIntegrationName === item.name && loading }"
                            @click="openIntegration(item)"
                        >
                            <BaseCard
                                aria-label="inner content shows on hover"
                                hover
                                class="overflow-visible h--100 card-solid-light"
                            >
                                <template #card-body>
                                    <div class="outer__wrap">
                                        <div class="flex align-items-baseline w-100 justify-content-between">
                                            <div class="flex w-100 mt--3">
                                                <IntegrationLogos v-if="item.key" :name="item.key" />
                                                <div class="ml--10 flex-2">
                                                    <div class="flex align-items-baseline w--100 justify-content-between">
                                                        <div class="flex align-items-center w-100 mr--10">
                                                            <p class="text--capitalize text--sm text--semi--bold text-gray-800 mr--10">
                                                                {{ item.name }}
                                                            </p>
                                                            <IconSvg
                                                                v-if="userIntegrationsMap[item.key]" name="check"
                                                                fill="#228E9D"
                                                            />
                                                        </div>

                                                        <template v-if="!availableOnPlan(item)">
                                                            <span 
                                                                class="status__map text--medium text--xs tag bold badge rounded-pill tag--pink text--upper"
                                                            >
                                                                <span 
                                                                    class="status__circle tag--pink__text" 
                                                                />
                                                                Not available on plan
                                                            </span>
                                                        </template>
                                                    </div>
                                                    <p class="text--capitalize text--xs text-gray-600 mt--3">
                                                        By {{ item.developedBy }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </BaseCard> 
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { IconSvg, EmptyPage, PageSpinner, IntegrationLogos, BaseCard } from "@/components/ui/index";
import { integrationProvidersLogos } from "@/utils/enums";

export default {
    name: "AllIntegrations",

    components: {
        IconSvg,
        EmptyPage,
        PageSpinner,
        IntegrationLogos,
        BaseCard,
    },

    props: {
        loading: {
            type: Boolean,
            default: false,
        },

        selectedIntegrationName: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            pageState: {
                loading: false,
                err: false,
                errMsg: "",
            },
            integrationProvidersLogos,
        };
    },

    computed: {
        integrations() {
            return this.$store.getters["config/integrations"];
        },

        userIntegrationsMap() {
            const userList = this.$store.getters["integration/integrations"] || [];
            const obj = {};
            
            for (let i = 0; i < userList.length; i++) {
                const item = userList[i];

                if (item?.enabled) {
                    obj[item.key] = true;
                }
            }
            
            return obj;
        },

        subscriptionInfo() {
            return this.$store.getters["subscription/subscriptionInfo"];
        },

        accountPlan() {
            return this.subscriptionInfo?.plan || "free";
        },
    },

    methods: {
        async handleFetchAllIntegrations(params = {}) {
            try {
                this.pageState.loading = true;
                this.pageState.errMsg = "";
                this.pageState.err = false;

                await this.$store.dispatch("config/fetchSystemIntegrations", { refresh: params?.refresh, params });
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.pageState.err = true;
                this.pageState.errMsg = errMsg;
            } finally {
                this.pageState.loading = false;
            }
        },

        availableOnPlan(item) {
            if (!item) return false;

            const itemPlans = item.allowedAccountTiers;
            const isPlanIncluded = itemPlans.includes(this.accountPlan);

            if (!isPlanIncluded) return false;

            return true;
        },

        openIntegration(item) {
            const obj = { ...item, enabled: this.userIntegrationsMap[item.key] ? true : false };            
            this.$emit("open-modal", obj);
        },
    },
};
</script>

<style lang="scss" scoped>
.integration {
    &__tier {
        display: flex;
        align-items: center;
        background: #e1e6f6;
        border-radius: 50px;
        padding: 3px 8px;
        justify-content: center;
        font-size: 10px;
        margin-right: 5px;
        margin-bottom: 10px;
        width: fit-content;
        text-transform: capitalize;
        color: var(--grey-600);
    }

    &_list__item {
        border-bottom: 1px solid #eee;
        padding-bottom: 19px;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        font-weight: 400;
        justify-content: space-between;
        width: 100%;
    }
}
</style>